import { add, getTime, parseISO } from "date-fns";
import { format } from "date-fns-tz";

export const parseDateOnly = (str: string): Date => {
  try {
    const matches = str.match(RegExp(/^([0-9]{4})-([0-9]{2})-?([0-9]{2})?.*$/));
    if (matches) {
      const [, year, month, day] = matches;

      // we allow 2023-08 format also, so we need to set day to 1 if it is undefined so that new Date still works
      const dayToUse = day !== undefined ? Number(day) : 1;

      // month is 0-indexed
      return new Date(Number(year), Number(month) - 1, dayToUse);
    }
  } catch {}

  // fallback if parsing year. month and day does not work
  return new Date(str);
};

export const datetimeToTimestamp = (date: string): number =>
  getTime(parseISO(date));

export const extractDateFromDateTime = (str: string): string => {
  try {
    const matches = str.match(RegExp(/^([0-9]{4})-([0-9]{2})-([0-9]{2}).*$/));
    if (matches) {
      const [, year, month, day] = matches;

      return `${year}-${month}-${day}`;
    }
  } catch {}

  // fallback if parsing year. month and day does not work
  return str;
};

// we set days to 15 to avoid problems with timezones/long months, which date-dns has problems with
// example 1: 2022-01-01 + one month = 2022-01-31.
// example 2: 2022-02-01 00:00:00 + 1 month = 2022-03-01 00:00:00, which gets converted to "2022-02" in this timezone
export const increaseOneMonth = (group: string): string =>
  format(
    add(new Date(`${group}-01`).getTime(), { months: 1, days: 15 }),
    "yyyy-MM"
  );
